module.exports = window["MaterialUI"].Slide;